module.exports = __webpack_public_path__ + "img/book-02_1.46f27893.png";